import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useUser } from "../../shared/context/UserContext";
import { SearchProvider } from "../../business-types/grocery/components/SearchContext";
import { fontStyles } from "../services/themes";
import Menu from "../../business-types/grocery/components/Menu";
import Header from "../../business-types/grocery/components/Header";
import GroceryHome from "../../business-types/grocery/layouts/Home/GroceryHome";
import SettingNavigation from "../../business-types/grocery/layouts/setting/settingRouters/SettingNavigation";
import OrderTable from "../../business-types/grocery/layouts/orders/OrderTable";
import SpecifiedOrderDisplay from "../../business-types/grocery/layouts/orders/SpecifiedOrderDisplay";
import LedgerTable from "../../business-types/grocery/layouts/ledgers/LedgerTable";
import SpecifiedLedgerDetails from "../../business-types/grocery/layouts/ledgers/ledgerDetails/SpecifiedLedgerDetails";
// import SpecifiedLedgerDetails from "src/business-types/grocery/layouts/ledgers/SpecifiedLedgerDetails";
import Dashboard from "../../business-types/grocery/layouts/dashboard/Dashboard";
import { OverallBg } from "../modules/profile/theme/themeCheacker";
import { ToastContainer } from "react-toastify";
import DailyReport from "../modules/reports/DailyReport";
import NotFound from "../modules/admin/NotFound";
import PermissionRoute from "../components/PermissionRoute";
import GroceryProfile from "./GroceryProfile";
import MyProfile from "src/business-types/grocery/layouts/profile/MyProfile";
import { useProfile } from "../hooks/useProfile";
import LoadingScreen from "../components/LoadingScreen";
import OrderReturn from "src/business-types/grocery/layouts/orders/orderReturn/OrderReturn";
import LogoutConfirmPopup from "src/business-types/grocery/components/Logout";
import PopupModules from "src/features/auth/components/PopupModules";

function GroceryNavigations() {
  const [menuVisval, setMenuVisval] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const [pageTitle, setPageTitle] = useState<string>();
  const location = useLocation();
  const token = sessionStorage.getItem("jsonwebtoken");
  const { user } = useUser();
  const { profileData } = useProfile();
  const [logoutPopupOpen, setLogoutPopupOpen] = useState(false);

  useEffect(() => {
    setPageTitle("");
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuVisval(false);
      }
    };

    if (menuVisval) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuVisval]);

  // ❌ TOKEN NOT FOUND → 404
  if (!token) {
    return (
      <Routes>
        <Route path='*' element={<NotFound />} />
      </Routes>
    );
  }
  if (!user) {
    return <LoadingScreen />;
  }
  return (
    <SearchProvider>
      <div className={`flex flex-col w-screen h-screen overflow-hidden ${fontStyles[user?.themes.fontFamily || "Sans-serif"]}`} ref={menuRef}>
        <Header MenubarVisval={setMenuVisval} MenuClose={menuVisval} pageTitle={pageTitle} logout={() => setLogoutPopupOpen(true)} />

        <div className={`flex w-full flex-1 overflow-hidden ${OverallBg()}`}>
          {menuVisval && <Menu menubar={() => setMenuVisval(false)} />}
          <div className='flex-1 overflow-y-auto'>
            <Routes>
              <Route path='/' element={<Navigate to='/Home' replace />} />
              <Route path='/Home' element={<GroceryHome />} />
              <Route
                path='/admin/*'
                element={
                  <PermissionRoute permission='management_view'>
                    <SettingNavigation />
                  </PermissionRoute>
                }
              />
              <Route
                path='/orders'
                element={
                  <PermissionRoute permission='order_view'>
                    <OrderTable />
                  </PermissionRoute>
                }
              />
              <Route
                path='/order_return'
                element={
                  <PermissionRoute permission='order_cancel'>
                    <OrderReturn />
                  </PermissionRoute>
                }
              />
              <Route
                path='/orders/:orderid'
                element={
                  <PermissionRoute permission='order_view'>
                    <SpecifiedOrderDisplay />
                  </PermissionRoute>
                }
              />
              <Route path='/reports' element={<DailyReport />} />
              <Route
                path='/setting/*'
                element={
                  <PermissionRoute permission='setting_view'>
                    <GroceryProfile user={user} prodileId={profileData?._id?.$oid || ""} />
                  </PermissionRoute>
                }
              />
              <Route
                path='/ledgers'
                element={
                  <PermissionRoute permission='customer_view'>
                    <LedgerTable />
                  </PermissionRoute>
                }
              />
              <Route
                path='/ledgers/:ledgerId'
                element={
                  <PermissionRoute permission='customer_view'>
                    <SpecifiedLedgerDetails pageTitle={(data) => setPageTitle(data)} />
                  </PermissionRoute>
                }
              />
              <Route
                path='/dashboard'
                element={
                  <PermissionRoute permission='dashboard_view'>
                    <Dashboard />
                  </PermissionRoute>
                }
              />
              <Route
                path='/profile'
                element={
                  <PermissionRoute permission='dashboard_view'>
                    <MyProfile user={user} prodileId={profileData?._id?.$oid || ""} />
                  </PermissionRoute>
                }
              />

              {/* ❌ URL NOT MATCH → 404 */}
              <Route path='*' element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </div>
      <PopupModules isOpen={logoutPopupOpen} onClose={() => setLogoutPopupOpen(false)} title={"Logout Confirmation"}>
        <LogoutConfirmPopup cancelLogout={() => setLogoutPopupOpen(false)} />
      </PopupModules>

      <ToastContainer />
    </SearchProvider>
  );
}

export default GroceryNavigations;
